import { memo } from "react";
import { Modal } from "react-bootstrap";
import { Button } from "shared/ui";

function FileRemovalModal({ removalConfirmation, onHide, handleFileRemoval }) {
  const onRemove = () => {
    handleFileRemoval(removalConfirmation.fileData);
    onHide();
  };
  return (
    <Modal show={removalConfirmation.show} onHide={onHide}>
      <Modal.Header closeButton>
        <Modal.Title>File deletion</Modal.Title>
      </Modal.Header>
      <Modal.Body>{`Are you sure you want to delete stored file ${
        removalConfirmation?.fileData?.original_name ?? ""
      } ?`}</Modal.Body>
      <Modal.Footer>
        <Button variant="outline-primary" onClick={onHide}>
          Cancel
        </Button>
        <Button variant="primary" onClick={onRemove}>
          Delete
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default memo(FileRemovalModal);
